import { httpCallEndAction } from './actions';

export const httpMiddleware = (dispatch: any) => (next: any) => (action: any) => {
  return dispatchHttpCallEndAction(dispatch, next, action);
};

const dispatchHttpCallEndAction = (dispatch: any, next: any, action: any) => {
  const httpEnd = action.meta && action.meta.httpEnd;

  if (!httpEnd) {
    return next(action);
  }
  else {
    const nextAction = cleanAction(action);
    next(nextAction);
    return next(httpCallEndAction());
  }
};

const cleanAction = (action: any) => ({
  ...action,
  meta: {
    ...action.meta,
    httpEnd: null,
  },
});


// WEBPACK FOOTER //
// ./src/middlewares/http/middleware.ts